// extracted by mini-css-extract-plugin
export default {"panel":"Panel_panel__0r851","content":"Panel_content__X473H","actionBar":"Panel_actionBar__w6jNs","divider":"Panel_divider__bPV2f"};